import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import colors from 'loankeeper-common/components/colors'

import { openFileDetails } from '../FileDetails'
import { activeNotesModalName, formName } from './constants'
import { translateActiveNotes } from './helpers'
import {
  ActiveNotesModal as SharedActiveNotesModal,
  openActiveNotesModal as openNotesModal,
} from '../shared/ActiveNotesChecker'
import { ActiveNotesModalProps, linkedFile } from './types'

export const openActiveNotesModal = () => openNotesModal(activeNotesModalName)

const getConfig = (
  handleOpenFileDetails: (modalParams: { ID: number | string; hash: string; type: string }) => void,
  files: linkedFile[],
) => {
  return {
    instanceName: 'client-details-active-notes',
    gridIdentity: { formName, objectName: 'dbgrd_notes' },
    enableColumnsResize: true,
    enableColumnsOrder: true,
    enableColumnsHide: true,
    enableSorting: false,
    enableTranslate: true,
    enableRowSelection: true,
    syncGridState: false,
    columnDefs: [
      { headerName: 'LoginFull', field: 'LoginFull', width: 250 },
      { headerName: 'Title', field: 'Title', width: 250 },
      { headerName: 'Comment', field: 'Comment', width: 250 },
    ],
    getRowStyle: ({
      node: {
        data: { Active },
      },
    }) => {
      if (Active === 2) {
        return { backgroundColor: colors.grey }
      }
      return {}
    },
    getContextMenuItems: ({
      node: {
        data: { LFLID, HashSum_FileID_: hash, Ext },
      },
    }: {
      node: {
        data: { LFLID: number | string; HashSum_FileID_: string; Ext: string }
      }
    }) => {
      if (!LFLID) {
        return []
      }

      let extension = Ext
      if (!extension) {
        const file = files.find((x) => x.ID === LFLID)
        if (file && file.Ext) {
          extension = file.Ext
        }
      }

      return [
        {
          name: translateActiveNotes('cmd_view_lfl'),
          action: () => {
            handleOpenFileDetails({
              ID: LFLID,
              hash,
              type: extension || 'jpg',
            })
          },
          icon: 'preview',
        },
      ]
    },
  }
}

const ActiveNotesModal: FC<ActiveNotesModalProps> = (props) => {
  const { fetching, notes, files, onRefresh, onClose } = props
  const dispatch = useDispatch()

  const handleOpenFileDetails = React.useCallback(
    (modalParams: { ID: number | string; hash: string; type: string }) => {
      dispatch(openFileDetails(modalParams))
    },
    [dispatch],
  )

  const gridConfig = React.useMemo(() => getConfig(handleOpenFileDetails, files), [handleOpenFileDetails, files])

  return (
    <SharedActiveNotesModal
      name={activeNotesModalName}
      isFetching={fetching}
      heading={translateActiveNotes('frm_RMD_All')}
      onRefresh={onRefresh}
      onClose={onClose}
      title={translateActiveNotes('pan_client')}
      notes={notes}
      gridConfig={gridConfig}
    />
  )
}

export default ActiveNotesModal
